/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
import * as React from 'react';
export function useControlledRef(_ref) {
  var controlled = _ref.controlled,
    defaultValue = _ref.default;
  var _React$useRef = React.useRef(controlled !== undefined),
    isControlled = _React$useRef.current;
  var valueRef = React.useRef(defaultValue);
  if (isControlled) {
    valueRef.current = controlled;
  }
  var setValue = React.useCallback(function (newValue) {
    valueRef.current = newValue;
  }, []);
  return [valueRef, setValue];
}